/**
 * Subscriptions store.
 *
 */

 import { Module, Action, getModule } from 'vuex-module-decorators';
 import PageBaseModule from '@/store/page';
 import store from '@/store';
 import PageEntity from '@/store/pageEntity';
 import { getList } from '@/api/crud';
 import ResponseHandlerModule from '@/store/modules/responseHandler';

 import { Subscriptions } from '@/models/subscriptions';
 import filterModel from '@/store/subscriptions/filterModel';
 import SubscriptionsFilter from '@/store/subscriptions/filterEntity';
 import { Filter } from '@/types/filter/filter';
import { TableApiInterface } from '@/types/page/table';
import { tabsNav } from './tabs';

 @Module({ dynamic: true, store, name: Subscriptions.moduleName, namespaced: true })
 class SubscriptionsModule extends PageBaseModule {
     allTabs = tabsNav;
     tabsNav = {};

     filter: Filter;

     constructor(module: SubscriptionsModule) {
         super(module);

         this.tabsNav = this.allTabs;

         const page = new PageEntity();
         page.setModuleName(Subscriptions.moduleName);
         page.setTitle(Subscriptions.listTitle);
         page.setTitleAdd(Subscriptions.createTitle);
         page.setTitleEdit(Subscriptions.editTitle);
         page.values.actionPagination = 'subscriptions/updatePage';
         page.values.actionPageAmountItems = 'subscriptions/updatePageAmountItems';
         page.values.pageAmountItems = 50;
         this.pageSettings = page.values;
         this.pageSettings.routeName = `${Subscriptions.moduleName}_edit`;
         this.pageSettings.routeParam = `${Subscriptions.moduleName}Id`;

         const filter = new filterModel();
         this.filter = getModule(SubscriptionsFilter);
         this.filter.setFilterName('SubscriptionsFilter');
         this.filter.setTemplateClassName('template-lg directory-filters');
         this.filter.setFilterModel(filter.filterModel);
         this.filter.setFilterHandlers(filter.filterHandlers);
     }

     @Action({ rawError: true })
     async init() {
         await this.getList();
     }

     @Action({ rawError: true })
     async getList() {
         try {
             const sort = await this.getSortForRequest();
             const result = await getList(Subscriptions.apiPrefix,
                 {
                     page: this.pageSettings.pageCurrent,
                     items: this.pageSettings.pageAmountItems,
                 },
                 sort,
                 this.filter.filterSettings.filter,
             );
             const table = await this.context.dispatch('processList', result.table);
             await this.context.dispatch('setList', table);
         } catch (clientError: any) {
             const error = clientError.response.data;

             ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

             await this.context.dispatch('updatePage', 1);
         }
     }

     @Action({ rawError: true })
     processList(table: TableApiInterface) {
        table.titles.unshift({ id: 'title', name: 'Подписка', visible: true });
        table.rows = table.rows.map(row => {
            return {
                title: `Подписка ${row.id}`,
                ...row,
            };
        });

        return table;
     }
 }

 export default getModule(SubscriptionsModule);
